// T44 + T48: one badge everywhere (cards, PDP, search, cart, checkout). Ex-demo units AND staff-tagged clearance items read
// "Ex-Demo & Clearance" (the collection's name); the T43 title safety still keeps "DEMO" in demo-unit titles.
export const isDemo = (p) => !!p && (p.is_demo || /^\s*de-/i.test(p.mpn || p.manufacturer_part_number || "") || /\bdemo\b/i.test(p.display_name || p.name || ""));
export const isClearance = (p) => !!p && (p.is_clearance || isDemo(p));

export const DemoBadge = ({ p, className = "", testid = "demo-badge" }) => (isClearance(p) ? (
  <span data-testid={testid} title={isDemo(p) ? "Ex-demonstration stock - not a new retail unit. Condition confirmed before you pay." : "Clearance item - condition confirmed before you pay."}
    className={`inline-flex items-center rounded-full border border-slate-300 bg-slate-50 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-slate-700 ${className}`}>
    Ex-Demo &amp; Clearance
  </span>
) : null);
